export default "__VITE_ASSET__218rFJCa__"